import { authServices, crudService } from '../_services/'
import { history } from '../utils'
import { toast } from 'react-toastify'

export const authActions = {
  login,
  facebookLogin,
  refresh,
  logout
}

const $package = require('../../package.json')
const versaoApp = $package?.version || '0.0.0'

function login(username, password) {
  return (dispatch) => {
    dispatch(request({ username }))
      let apiEndpoint = 'authentication/login'
    let payload = {
      login: username,
      senha: password,
      admin: true
    }
    authServices
      .post(apiEndpoint, payload)
      .then((response) => {
        dispatch(success(response.data))
        history.push('/principal')
      })
      .catch((err) => {
        dispatch(failure(err))
      })
  }

  function request(user) {
    return { type: 'LOGIN_REQUEST', user }
  }

  function success(user) {
    return {
      type: 'LOGIN_SUCCESS',
      token: user.token,
      expires: user.expires,
      user: user.usuario
    }
  }

  function failure(error) {
    return { type: 'LOGIN_FAILURE', error }
  }
}

function refresh() {
  return (dispatch) => {
    const token = localStorage.getItem('token')

    const payload = {
      admin: true,
      plataforma: navigator?.userAgent,
      versaoApp: versaoApp
    }

    if (token !== null && token !== undefined) {
      dispatch(request(token))
      let apiEndpoint = 'authentication/refresh/v2'
      crudService
        .postWithToken(apiEndpoint, payload, token)
        .then((response) => {
          dispatch(success(response.data))
        })
        .catch((err) => {
          dispatch(failure(err))
          dispatch(logout())
        })
    }
  }

  function request(token) {
    return { type: 'AUTHENTICATION_REFRESH_REQUEST', token }
  }

  function success(user) {
    return {
      type: 'AUTHENTICATION_REFRESH_SUCCESS',
      user: user.usuario
    }
  }

  function failure(error) {
    return { type: 'AUTHENTICATION_REFRESH_FAILURE', error }
  }
}

function facebookLogin(facebookToken, createUser) {
  return (dispatch) => {
    dispatch(request({ createUser }))
    let apiEndpoint = 'authentication/facebook'
    let payload = {
      facebookToken: facebookToken,
      createUser: createUser
    }
    authServices
      .post(apiEndpoint, payload)
      .then((response) => {
        dispatch(success(response.data))
        history.push('/principal')
      })
      .catch((err) => {
        dispatch(failure(err))
        toast.error('Opss! Problema ao autenticar usuário! 😥')
      })
  }

  function request(user) {
    return { type: 'LOGIN_REQUEST', user }
  }

  function success(user) {
    return {
      type: 'LOGIN_SUCCESS',
      auth: user.auth,
      token: user.token,
      expires: user.expires,
      user: user.usuario
    }
  }

  function failure(error) {
    return { type: 'LOGIN_FAILURE', error }
  }
}

function logout() {
  return (dispatch) => {
    authServices.logout()
    dispatch(logoutUser())
    history.push('/login')
  }
}
export function setUserDetails(user) {
  return {
    type: 'LOGIN_SUCCESS',
    auth: user.auth,
    token: user.token,
    expires: user.expires,
    user: user.usuario
  }
}
export function logoutUser() {
  return {
    type: 'LOGOUT_SUCCESS'
  }
}
